<template>
  <div id="aba-anexo-registro-auxiliar">
    <anexos-wrapper nome="Anexos" entidade="REGISTRO_AUXILIAR" :id="ficha.id" :permite-assinar-documentos="true"/>
  </div>
</template>

<script>
  import AnexosWrapper from "@/components/Anexos/AnexosWrapper.vue";

  export default {

    name: "Anexos",
    components: {AnexosWrapper},
    props: {
      ficha: Object,
    },

    data() {
      return {
      }
    },

    methods: {
    }
  }
</script>
